<script lang="ts">
    import Link from "svelte-link";
    import { Image } from "sveltestrap";
    import { href } from "../../../../utils/Constant/Constant";
    import data from "../../../../Data/Chat/Chat.json"
    import {selectList,tabOpen} from "../../../../store"
    import 'emoji-picker-element';
    let imgPath:string = "/assets/images/user"
    let setSelectList:any
    selectList.subscribe((value)=>{
      setSelectList = value
    })
</script>
<div class="media chat-header clearfix">
    {#each setSelectList as chatItem}
      <Image class="rounded-circle" src="{imgPath}/{chatItem.img}" alt="" />
      <div class="media-body">
          <div class="about">
              <div class="name">{chatItem.name}</div>
              <div class="status">{'Last Seen 3:55 PM'}</div>
          </div>
      </div>
    {/each}
    <ul class="list-inline float-start float-sm-end chat-menu-icons">
      {#each data.icondata as chatItem}
        <li class="list-inline-item">
            <Link href={href}><i class={chatItem.icon}></i></Link>
        </li>
      {/each} 
      <li class="list-inline-item toogle-bar">
        <Link href={href} on:click={()=>{tabOpen.update(value => value = !value)}}>
          <i class="icon-menu"></i>
        </Link>
      </li>
    </ul>
</div>